
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import CatalogListGrid from "../../../common/catalog/CatalogListGrid";
import CatalogListSection from "../../../common/catalog/CatalogListSection";
import CatalogEmptyState from "../../../common/catalog/CatalogEmptyState";
import { getCatalogEmptyCopy } from "../../../common/catalog/catalogEmptyCopy";
import { fetchCatalogListPage } from "../../../common/catalog/fetchCatalogListPage";
import Paginator from "../../../common/paginator/Paginator";
import Skeleton from "../../../common/loading/Skeleton";
import Publication from "../common/Publication";

export default function PublicationSection({ isDesktop, query }) {
	const navigate = useNavigate();
	const [publications, setPublications] = useState([]);
	const [page, setPage] = useState(1);
	const [maxPageNum, setMaxPageNum] = useState(1);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchPublications(1);
	}, []);

	useEffect(() => {
		if (page !== 1) {
			setPage(1);
		}
		fetchPublications(1);
	}, [query]);

	useEffect(() => {
		fetchPublications(page);
	}, [page]);

	function fetchPublications(currentPage) {
		if (isLoading) {
			return;
		}
		setIsLoading(true);
		let queryParam = query ? query : '';
		fetchCatalogListPage({
			fetchPage: (params) => api.publicationSearch(params),
			baseParams: { query: queryParam },
			displayPage: currentPage,
			listKey: "publications",
		})
			.then(({ items, maxPage }) => {
				setPublications(items);
				setMaxPageNum(maxPage);
				setIsLoading(false);
			})
			.catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	const emptyCopy = getCatalogEmptyCopy({
		itemSingular: "مقاله",
		query,
	});

	const pagination =
		publications.length >= 1 && maxPageNum >= 2 ? (
			<Paginator
				currentPage={page}
				maxPageNum={maxPageNum}
				isLoading={isLoading}
				onChange={(newPage) => {
					setPage(newPage);
				}}
			/>
		) : null;

	return (
		<CatalogListSection pagination={pagination}>
			<h1 className="mb-2 font-Vazir-700 text-[18px] text-darkBlue md:text-[20px]">
				مقالات
			</h1>
			{publications.length === 0 && isLoading && (
				<Skeleton variant="grid" type="publication" count={8} />
			)}
			{publications.length >= 1 && (
				<CatalogListGrid isDesktop={isDesktop}>
					{publications.map((publication) => (
						<Publication key={publication.id} publication={publication} />
					))}
				</CatalogListGrid>
			)}
			{publications.length === 0 && !isLoading && !errorMessage && (
				<CatalogEmptyState
					message={emptyCopy.message}
					hint={emptyCopy.hint}
					actionLabel={emptyCopy.showClear ? "پاک کردن جستجو" : undefined}
					onAction={
						emptyCopy.showClear
							? () => navigate("/publication_list/")
							: undefined
					}
				/>
			)}
			{errorMessage && (
				<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
			)}
		</CatalogListSection>
	)
}
